import { createTheme } from "@mui/material/styles";
import { COMPONENTS, LIGHT, PRIMARY_COLOR, TYPOGRAPHY } from "../enums/themeEnums";

const lightTheme = createTheme({
  palette: {
    mode: LIGHT,
    primary: {
      main: "#4A3F35"
    },
    background: {
      default: '#FAF7F2',
      paper: '#FFFDFB'
    },
    text: {
      primary: '#3C3633',
      secondary: '#7E746D'
    },
    divider: 'rgba(74, 63, 53, 0.15)'
  },
  shape: {
    borderRadius: 12
  },
  typography: { ...TYPOGRAPHY },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FAF7F2',
          color: '#3C3633',
          padding: 0,
          margin: 0,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundImage: `radial-gradient(circle at 50% 50%, transparent 0%, #FAF7F2 75%), url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='1' cy='1' r='1' fill='%234A3F35' fill-opacity='0.12'/%3E%3C/svg%3E")`,
          backgroundAttachment: 'fixed',
          backgroundSize: '100% 100%, 24px 24px',
        },
        '::selection': {
          backgroundColor: '#4A3F35',
          color: '#FAF7F2',
        },
        '.MuiDialog-root .MuiBackdrop-root': {
          backgroundColor: 'rgba(250, 247, 242, 0.8) !important',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFDFB',
          border: '1px solid #E8E2D9',
          borderRadius: '12px',
          boxShadow: '0 30px 60px rgba(74, 63, 53, 0.12)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFDFB',
          border: '1px solid #E8E2D9',
          borderRadius: '12px',
          boxShadow: 'none',
          padding: '32px',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: '#D4CBBF',
            boxShadow: '0 4px 12px rgba(74, 63, 53, 0.05)',
          },
        }
      }
    },
    ...COMPONENTS
  }
});

export default lightTheme;